import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { canonicalRedirect, isFramed } from "@/lib/shellGuards";

const IS_PRODUCTION = process.env.NODE_ENV === "production";
const target = canonicalRedirect(window.location, process.env.REACT_APP_BACKEND_URL, process.env.NODE_ENV);
if (target) {
  window.location.replace(target);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Framing is closed on every route until the dedicated embed route exists (ADR-016). Production builds only: the hosting
// preview panel legitimately frames the development server.
function FramedRefusal() {
  return (
    <main className="min-h-screen flex items-center justify-center bg-[#0A0C0E] text-[#E6E8EB] p-8" data-testid="framed-refusal">
      <div className="max-w-md space-y-3 text-center">
        <p className="text-base font-semibold">BIZII cannot be displayed inside another page.</p>
        <p className="text-sm text-[#9AA3AD]">Open the application directly to continue.</p>
        <a className="text-sm underline" href={process.env.REACT_APP_BACKEND_URL} target="_top" rel="noopener noreferrer" data-testid="framed-refusal-link">
          Open BIZII
        </a>
      </div>
    </main>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
if (!target) {
  root.render(
    <React.StrictMode>
      {IS_PRODUCTION && isFramed(window) ? (
        <FramedRefusal />
      ) : (
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      )}
    </React.StrictMode>,
  );
}
